
$(document).ready(function() {
    let html = "";

    if (is_mobile()) {
        html += "<div class='back-school-season mobile-only'>";
        html += "<a href='https://www.ruko.net/pages/christmas-sale-up-to-67-off'><img src='' class='hover-image' width='100%' /></a>";
        html += "</div>";
    } else {
        html += "<div class='back-school-season pc-only'>";
        html += "<a href='https://www.ruko.net/pages/christmas-sale-up-to-67-off'><img src='' class='hover-image' width='100%' /></a>";
        html += "</div>";
    }

    if ($('.deals-section:eq(0)').length > 0) {
        $('.deals-section:eq(0)').before(html);
    } else {
        $('.hdt-sec-slideshow.shopify-section:eq(0)').append(html);
    }
});

function is_mobile() {
    let isMobile = $(window).width() <= 960;
    return isMobile;
}